import { getTimeZones } from '@vvo/tzdb'
import type { KNAdvancedDropdownOption } from 'components/KNAdvancedDropdown/types'

export const getTimezoneOptions = (): KNAdvancedDropdownOption[] =>
  getTimeZones({ includeUtc: true }).map((timezone) => ({
    value: timezone.name,
    label: timezone.currentTimeFormat,
  }))
